"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftPresetsApplicationService = void 0;
const operators_1 = require("rxjs/operators");
class ShiftPresetsApplicationService {
    constructor(repo) {
        this.repo = repo;
    }
    findShiftPresets(tenantId) {
        return this.repo.getForTenant(tenantId);
    }
    async addShiftPreset(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.mayAddPreset(command.preset)) {
            return { status: 'rejected' };
        }
        await this.repo.put(presets.withPresetAdded(command.preset));
        return { status: 'accepted' };
    }
    async removeShiftPreset(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name ${command.presetName} does not exist`,
            };
        }
        await this.repo.put(presets.withPresetRemoved(command.presetName));
        return { status: 'accepted' };
    }
    async renameShiftPreset(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.oldName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.oldName}' does not exist`,
            };
        }
        if (presets.hasPresetWithName(command.newName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.newName}' does already exist`,
            };
        }
        await this.repo.put(presets.withPresetRenamed(command.oldName, command.newName));
        return { status: 'accepted' };
    }
    async changeShiftPresetPrice(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetPriceChanged(command.presetName, command.newPrice));
        return { status: 'accepted' };
    }
    async changeShiftPresetLocation(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetLocationChanged(command.presetName, command.newLocation));
        return { status: 'accepted' };
    }
    async changeShiftPresetDescription(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetDescriptionChanged(command.presetName, command.newDescription));
        return { status: 'accepted' };
    }
    async changeCrewMembersCanAttendPreset(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetCrewMembersCanAttendChanged(command.presetName, command.crewMembersCanAttend));
        return { status: 'accepted' };
    }
    async changeChildrenCanAttendPreset(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetChildrenCanAttendChanged(command.presetName, command.childrenCanAttend));
        return { status: 'accepted' };
    }
    async changePresetStartAndEnd(command) {
        const presets = await this.findShiftPresets(command.tenantId)
            .pipe(operators_1.first())
            .toPromise();
        if (!presets.hasPresetWithName(command.presetName)) {
            return {
                status: 'rejected',
                reason: `A shift preset with the name '${command.presetName}' does not exist`,
            };
        }
        await this.repo.put(presets.withPresetStartAndEndChanged(command.presetName, command.startAndEndTime));
        return { status: 'accepted' };
    }
}
exports.ShiftPresetsApplicationService = ShiftPresetsApplicationService;
//# sourceMappingURL=shift-presets.application-service.js.map